import React, { useState } from 'react';
import {
  Button,
  Container,
  Box,
  Modal,
  Tooltip,
  TextField,
  Typography,
  Paper,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const AddExpenseGroup = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [formData, setFormData] = useState({
    expenseGroup: '',
    remark: '',
    taxType: '5%', // Default selection
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSave = (e) => {
    e.preventDefault();
    // Check if all required fields are filled
    if (!formData.expenseGroup || !formData.remark) {
      alert('Please fill all fields');
      return;
    }
    setShowSuccessModal(true);
  };

  const handleCancel = () => {
    setFormData({
      expenseGroup: '',
      remark: '',
      taxType: '5%',
    });
  };

  return (
    <Container>
      <Box
        sx={{
          backgroundColor: 'rgba(2, 78, 101, 1)',
          padding: '12px 16px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '0 auto',
          width: '100%',
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
          Add Expense Group
        </Typography>
      </Box>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6, backgroundColor: '#f8fdfeff' }}>
        <form onSubmit={handleSave}>
          <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
            <TextField
              label="Expense Group"
              variant="outlined"
              fullWidth
              name="expenseGroup"
              value={formData.expenseGroup}
              onChange={handleChange}
            />
          </Box>
          <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
            <TextField
              label="Remark"
              variant="outlined"
              fullWidth
              name="remark"
              value={formData.remark}
              onChange={handleChange}
            />
          </Box>
          <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
            <FormControl component="fieldset">
              <Typography component="legend">Tax Type</Typography>
              <RadioGroup row aria-label="taxType" name="taxType" value={formData.taxType} onChange={handleChange}>
                <FormControlLabel value="5%" control={<Radio />} label="5%" />
                <FormControlLabel value="zero-rated" control={<Radio />} label="Zero-rated" />
                <FormControlLabel value="exempted" control={<Radio />} label="Exempted" />
              </RadioGroup>
            </FormControl>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Tooltip
              title={
                (!formData.expenseGroup && 'Enter Expense Group') ||
                (!formData.remark && 'Enter Remark')
              }
              arrow
            >
              <Button
                variant="contained"
                type="submit"
                sx={{ mr: 2, backgroundColor: '#127498ff', '&:hover': { backgroundColor: '#116280ff' } }}
                disabled={!formData.expenseGroup || !formData.remark}
              >
                SAVE
              </Button>
            </Tooltip>
            <Button variant="contained" color="error" onClick={handleCancel}>
              RESET
            </Button>
          </Box>
        </form>
      </Paper>
      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Expense Group Added ✅
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Expense Group Added Successfully
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default AddExpenseGroup;
